import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  SUPPLIER_PATH,
  NEW_SUPPLIER_PATH,
  FOOD_UNIT_PATH,
  ITINERARY_SUPPLIER_FOOD_PATH,
  NEW_ITINERARY_SUPPLIER_FOOD_PATH,
  ITINERARY_SUPPLIER_FOOD_REPORT_PATH,
  ITINERARY_FOOD_INVOICE_PATH,
  NEW_ITINERARY_FOOD_INVOICE_PATH,
} from '../../../config/paths';
import Suppliers from './supplier/Suppliers';
import NewSupplier from './supplier/NewSupplier';
import Supplier from './supplier/Supplier';
import EditSupplier from './supplier/EditSupplier';
import FoodHome from './FoodHome';
import NewItinerarySupplierFood from './itinerary-supplier-food/NewItinerarySupplierFood';
import ItinerarySupplierFood from './itinerary-supplier-food/ItinerarySupplierFood';
import ItinerarySupplierFoods from './itinerary-supplier-food/ItinerarySupplierFoods';
import ItinerarySupplierFoodReport from './itinerary-supplier-food-report/ItinerarySupplierFoodReport';
import ItineraryFoodInvoices from './itinerary-food-invoice/ItineraryFoodInvoices';
import NewInvoiceFoodInvoice from './itinerary-food-invoice/NewInvoiceFoodInvoice';
import ItineraryFoodInvoice from './itinerary-food-invoice/ItineraryFoodInvoice';
import EditineraryFoodInvoice from './itinerary-food-invoice/EditineraryFoodInvoice';

const FoodUnit = () => (
  <Switch>
    <Route exact path={FOOD_UNIT_PATH} component={FoodHome} />

    <Route exact path={SUPPLIER_PATH} component={Suppliers} />
    <Route exact path={NEW_SUPPLIER_PATH} component={NewSupplier} />
    <Route exact path={`${SUPPLIER_PATH}/:id`} component={Supplier} />
    <Route exact path={`${SUPPLIER_PATH}/:id/edit`} component={EditSupplier} />
    <Route
      exact
      path={ITINERARY_SUPPLIER_FOOD_PATH}
      component={ItinerarySupplierFoods}
    />
    <Route
      exact
      path={NEW_ITINERARY_SUPPLIER_FOOD_PATH}
      component={NewItinerarySupplierFood}
    />
    <Route
      exact
      path={`${ITINERARY_SUPPLIER_FOOD_PATH}/:id`}
      component={ItinerarySupplierFood}
    />
    <Route
      exact
      path={`${ITINERARY_SUPPLIER_FOOD_REPORT_PATH}`}
      component={ItinerarySupplierFoodReport}
    />
    <Route
      exact
      path={ITINERARY_FOOD_INVOICE_PATH}
      component={ItineraryFoodInvoices}
    />
    <Route
      exact
      path={NEW_ITINERARY_FOOD_INVOICE_PATH}
      component={NewInvoiceFoodInvoice}
    />
    <Route
      exact
      path={`${ITINERARY_FOOD_INVOICE_PATH}/:id`}
      component={ItineraryFoodInvoice}
    />
    <Route
      exact
      path={`${ITINERARY_FOOD_INVOICE_PATH}/:id/edit`}
      component={EditineraryFoodInvoice}
    />
  </Switch>
);

export default FoodUnit;
